<template>
  <div class="hero is-fullheight fullpage-section" data-anchor="footer">
    <div class="column display-flex background-grey height100">
      <div class="column " style="height: 20vh"></div>
      <div class="columns is-centered">
        <div class="column is-3 is-paddingless-mobile">
          <div class="column is-4 is-paddingless" align="center">
            <div class="column is-5 is-3-mobile is-paddingless">
              <img :src="getImg('Footer/Contacto.png')" alt=""/>
            </div>
            <p
              class="has-font-unica footer-elements-color is-size-4 is-size-6-mobile"
            >
              Contacto
            </p>
          </div>
          <div class="column is-paddingless">
            <a class="has-text-black" href="mailto:contacto@calce.cl"
            >contacto@calce.cl<br/>
            </a>
            Lunes a Viernes<br/>
            10:00 a 13:00 - 14:00 a 18:00 horas
          </div>
        </div>
        <div class="column is-3 is-paddingless-mobile">
          <div class="column is-4 is-paddingless" align="center">
            <div class="column is-5 is-3-mobile is-paddingless">
              <img :src="getImg('Footer/Ubicacion.png')" alt=""/>
            </div>
            <p
              class="has-font-unica footer-elements-color is-size-4 is-size-6-mobile"
            >
              Ubicación
            </p>
          </div>
          <div class="column is-paddingless">
            <a class="has-text-black" href="https://www.google.com/maps/place/Tupper+2007,+Santiago,+Regi%C3%B3n+Metropolitana/
        @-33.4580169,-70.6641774,17z/data=!3m1!4b1!4m5!3m4!1s0x9662c504b63ed575:0x23465b96ed4e25c1!8m2!3d
        -33.4580169!4d-70.6619887">
              Av. Tupper #2007<br/>
              Comuna de Santiago<br/>
              Región Metropolitana, Chile
            </a>
          </div>
        </div>
        <div class="column is-3 is-paddingless-mobile">
          <div class="column is-4 is-paddingless" align="center">
            <div class="column is-5 is-3-mobile is-paddingless">
              <img :src="getImg('Footer/Faq.png')" alt=""/>
            </div>
            <p
              class="has-font-unica footer-elements-color is-size-4 is-size-6-mobile"
            >
              Faq
            </p>
          </div>
          <div class="column is-paddingless">
            <a @click="navigateCatalogue" class="has-text-black">Catálogo<br/> </a>
            <a @click="navigateFaq" class="has-text-black"
            >Preguntas frecuentes<br/>
            </a>
          </div>
        </div>
      </div>

      <div class="column is-hidden-mobile" style="height: 5vh"></div>
      <div class="columns">
        <div class="column ">
          <div class="column" style="height: 10vh"></div>
          <div class="columns is-centered" align="center">
            <a
              class="column footer-images-conf is-6-mobile"
              href="https://www.instagram.com/calce3d/"
            >
              <img :src="getImg('Footer/instagram.png')" alt=""
              /></a>
            <a
              class="column footer-images-conf is-6-mobile"
              href="https://twitter.com/calce3d"
            >
              <img :src="getImg('Footer/twitter.png')" alt=""
              /></a>
            <a
              class="column footer-images-conf is-6-mobile"
              href="https://www.facebook.com/calce3d/"
            >
              <img :src="getImg('Footer/facebook.png')" alt=""
              /></a>
            <a
              class="column footer-images-conf is-6-mobile"
              href="https://www.linkedin.com/company/calce-3d"
            >
              <img :src="getImg('Footer/linkedin.png')" alt=""
              /></a>
            <!--<a class="column footer-images-conf is-5-mobile" href="">
              <img :src="getImg('Footer/Medium.png')" alt=""
            /></a>-->
          </div>
        </div>
        <div class="column is-half is-12-mobile is-paddingless">
          <div class="column is-half is-paddingless">
            <div
              class="column is-7 is-8-touch is-pulled-right is-paddingless"
              align="right"
            >
              <img :src="getImg('common/logocalce-new.png')" alt=""/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getImg } from "@/utils/AssetsHelper"

  export default {
    methods: {
      getImg,
      navigateFaq() {
        this.$router.push({ name: "Faq" })
      },
      navigateCatalogue() {
        this.$router.push({ name: "Catalogue" })
      }
    },
    data: function () {
      return {}
    }
  }
</script>

<style scoped>
  .height100 {
    height: 100vh;
  }

  .footer-elements-color {
    color: #00adee;
  }

  .background-grey {
    background-color: #dadae0;
  }

  @media screen and (orientation: landscape) {
    .footer-images-conf {
      flex: none;
      width: 10%;
    }
  }

  @media screen and (orientation: portrait) {
    .display-flex {
      display: flex;
    }
  }
</style>
